module.exports = __webpack_public_path__ + "media/bootstrap-icons/capslock-91a10e96.svg";